export default {"src":"/_next/static/image/public/images/grey_strips_bkg.91172518ed279f446f9dc1921469bf64.svg","height":52,"width":779};